import gql from 'graphql-tag'

export const ReducedUserPlanFragment = gql`
  fragment ReducedUserPlanFragment on UserPlan {
    id
    regime
    pnns_choice
    structure
    start_at
    created_at
    express
    preferences {
      moment
    }
    menu {
      day
      moments {
        moment
        meal {
          id
          name
          slug
          preparation_time
          baking_time
          rest_time
          benefits
          portions
          min_portions
          max_portions
          main_component
          unbreakable
          image
          image_alt
          cover_desktop
          cover_mobile
          cover_alt
          publication_platforms
          published
          archived
          recipe_category
          ranking
          seasons
          express
          nutriscore
          tags {
            name
            type
          }
          steps {
            order
            text
            image
            image_alt
          }
        }
      }
    }
  }
`
